module.exports = __webpack_public_path__ + "static/media/logo.7c467e71.gif";